import React from 'react'
import { render } from 'react-dom'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Provider } from 'react-redux'
import { reducer as formReducer } from 'redux-form'
import { createStore } from 'redux-dynamic-modules'
import { getSagaExtension } from 'redux-dynamic-modules-saga'

import queryClient from './queryClient'
import { initLogging } from './Logging/sentry-audience'
import { IntlProviderWrapper } from './i18n/IntlProviderWrapper'
import { Modal, ModalProvider } from './Layout/Modal'
import { WebinarAudienceRoomRoutesComponent } from './routes/WebinarAudienceRoomRoutesComponent'

const store = createStore(
  { extensions: [getSagaExtension(undefined)] },
  { id: 'form', reducerMap: { form: formReducer } }
)

const reactContainerNode =
  document.querySelector('.react-container') ??
  document.getElementById('main_container') ??
  document.body.appendChild(document.createElement('div'))

initLogging()

render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <IntlProviderWrapper>
        <div className="admin-root">
          <ModalProvider>
            <WebinarAudienceRoomRoutesComponent />
            <Modal />
            {/* TODO: remove?*/}
          </ModalProvider>
        </div>
        <ReactQueryDevtools />
      </IntlProviderWrapper>
    </QueryClientProvider>
  </Provider>,
  reactContainerNode
)
